import React from 'react';

import { CircularProgress } from '@mui/material';

import { CONTROLLER_ON } from '../../constants/colors';

interface StyledCircularProgressProps {
  size?: number;
}

const customStyles = {
  customLoading: {
    margin: 'auto',
    color: CONTROLLER_ON
  }
};

const StyledCircularProgress = ({ size = 20 }: StyledCircularProgressProps) => {
  return <CircularProgress sx={{ ...customStyles }} size={size} />;
};

export default StyledCircularProgress;
